import createPlugin, { LazyComponentsMap, PluginConstructorParams } from './create-plugin';

type ThemeConstructorParams = PluginConstructorParams & {
    app: LazyComponentsMap['app']
}

export default function createTheme({ app, ...others }: ThemeConstructorParams) {
    return createPlugin({
        components: {
            ...others.components,
            app,
        },
        ...others
    });
}
